/**
 * 유효 라우트 매니페스트 — queue #680 §R680-4.
 *
 * `router.tsx` 의 `<Route path>` 전체(파라미터 라우트 `:id`/`:requestId` 등 제외)에서 파생한
 * 404 유사 라우트 제안(`suggestRoute.ts`)의 후보 풀. `router.tsx` 는 JSX `<Routes>` 선언이라
 * 런타임 리플렉션이 불가능해 정적 목록으로 유지한다 — `router.tsx` 에 라우트를 추가/삭제할 때
 * 이 목록도 함께 갱신할 것.
 */
export const ROUTE_MANIFEST: readonly string[] = [
  '/login',
  '/password-reset/request',
  '/password-reset/confirm',
  '/password-reset/success',
  '/_index',
  '/gateway/services',
  '/gateway/routes',
  '/gateway/apis',
  '/gateway/targets',
  '/gateway/plugins',
  '/gateway/consumers',
  '/gateway/upstreams',
  '/gateway/certificates',
  '/gateway/consumer-groups',
  '/gateway/request-logs',
  '/logout',
  '/logout/inspector',
  '/dev/token-inspector',
  '/users',
  '/codes',
  '/me',
  '/permission-demo',
  '/audit-logs',
  '/audit-logs/me',
  '/roles',
  '/permissions',
  '/menus',
  '/showcase',
  '/showcase/feedback',
  '/error-demo',
  '/attachments',
  '/event-monitor',
  '/system-settings',
  '/admin/terminology',
  '/admin/terminology/standard-terms',
  '/admin/terminology/forbidden-words',
  '/admin/terminology/checker',
  '/standards',
  '/approval-center',
  '/approval-center/new',
  '/approval-center/mine',
  '/notification-center',
  '/report-builder',
  '/report-builder/new',
  '/report-builder/history',
  '/saga-monitor',
  '/tenant-switcher',
  '/retention-admin',
  '/retention-admin/history',
  '/config-center',
  '/integration-hub',
  '/integration-hub/storage',
  '/integration-hub/history',
  '/integration-hub/tcp',
  '/integration-hub/grpc',
  '/scheduler-monitor',
  '/change-history-viewer',
  '/cache-admin',
  '/realtime-console',
  '/platform-lab',
  '/getting-started',
  '/getting-started/consumer-guide',
  '/scaffold',
];
